"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsVisibleInApp = exports.visibleReferralNotifications = exports.visibleMultipleLotteriesNotifications = exports.visibleLotteryNotifications = void 0;
exports.visibleLotteryNotifications = [
    "not-selected",
    "lottery-number-received",
    "new-eligible-lotteries",
    "new-closed-applications",
];
exports.visibleMultipleLotteriesNotifications = [
    'applications-submitted',
];
exports.visibleReferralNotifications = [];
exports.notificationsVisibleInApp = [
    ...exports.visibleLotteryNotifications,
    ...exports.visibleReferralNotifications,
    ...exports.visibleMultipleLotteriesNotifications
];
